export default function DroneIcon({ className = "w-6 h-6" }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={className}>
      {/* Centro - corpo drone */}
      <rect x="10" y="10" width="4" height="4" rx="1" />
      {/* Bracci diagonali */}
      <line x1="10" y1="10" x2="5" y2="5" />
      <line x1="14" y1="10" x2="19" y2="5" />
      <line x1="10" y1="14" x2="5" y2="19" />
      <line x1="14" y1="14" x2="19" y2="19" />
      {/* Eliche (cerchi) */}
      <circle cx="4" cy="4" r="2.5" />
      <circle cx="20" cy="4" r="2.5" />
      <circle cx="4" cy="20" r="2.5" />
      <circle cx="20" cy="20" r="2.5" />
    </svg>
  );
}
